module.exports = __webpack_public_path__ + "img/hr-level1_mining_hands_shadow.f8e76a8a.png";